import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// PUBLIC_FIREBASE_CONFIG is inlined at bundle time via bunfig.toml [serve.static] env = "PUBLIC_*"
// It's a public client-side Firebase config — not a secret.
const config = JSON.parse(process.env.PUBLIC_FIREBASE_CONFIG ?? "{}");

const app = getApps().length === 0 ? initializeApp(config) : getApps()[0]!;

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
